webpackJsonp([248707572166302],{

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(66);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(65);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	if (typeof window !== "undefined" && window.IntersectionObserver) {
	  io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      listeners.forEach(function (l) {
	        if (l[0] === entry.target) {
	          // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	          if (entry.isIntersecting || entry.intersectionRatio > 0) {
	            io.unobserve(l[0]);
	            l[1]();
	          }
	        }
	      });
	    });
	  }, { rootMargin: "200px" });
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  io.observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n"], ["\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  bottom: 0;\n  background: ", ";\n  left: ", ";\n  padding-top: ", "px;\n  overflow: auto;\n  position: absolute;\n  top: 0;\n  width: ", ";\n\n  @media screen and (min-width: ", ") {\n    padding-top: ", "px;\n  }\n  @media screen and (min-width: ", ") {\n    display: block;\n    left: 0;\n    transition: all 0.6s ease;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  a {\n    display: block;\n    padding: ", ";\n    color: inherit;\n    text-decoration: none;\n    &:hover {\n      color: inherit;\n    }\n  }\n"], ["\n  display: ", ";\n  bottom: 0;\n  background: ", ";\n  left: ", ";\n  padding-top: ", "px;\n  overflow: auto;\n  position: absolute;\n  top: 0;\n  width: ", ";\n\n  @media screen and (min-width: ", ") {\n    padding-top: ", "px;\n  }\n  @media screen and (min-width: ", ") {\n    display: block;\n    left: 0;\n    transition: all 0.6s ease;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  a {\n    display: block;\n    padding: ", ";\n    color: inherit;\n    text-decoration: none;\n    &:hover {\n      color: inherit;\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-weight: 300;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 1.4em 0 0 1.3em;\n  letter-spacing: 0.2em;\n  font-size: 0.9em;\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-weight: 300;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 1.4em 0 0 1.3em;\n  letter-spacing: 0.2em;\n  font-size: 0.9em;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  list-style: none;\n  max-width: ", ";\n  margin: 0;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n"], ["\n  display: ", ";\n  list-style: none;\n  max-width: ", ";\n  margin: 0;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: ", ";\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\nfrom {\n  opacity: 0;\n}\nto {\n  opacity: 1;\n}\n"], ["\nfrom {\n  opacity: 0;\n}\nto {\n  opacity: 1;\n}\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  animation-name: ", ";\n  animation-duration: 0.5s;\n  background: ", ";\n  border-left: 0.4em solid\n    ", ";\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background 0.5s;\n  &:first-child {\n    border-top: ", ";\n  }\n"], ["\n  animation-name: ", ";\n  animation-duration: 0.5s;\n  background: ", ";\n  border-left: 0.4em solid\n    ", ";\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  transition: background 0.5s;\n  &:first-child {\n    border-top: ", ";\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  perspective: 1000px;\n"], ["\n  position: relative;\n  perspective: 1000px;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin: 0;\n  opacity: ", ";\n  padding-left: 5%;\n  transition: all 0.5s;\n\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n\n  a:hover & {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin: 0;\n  opacity: ", ";\n  padding-left: 5%;\n  transition: all 0.5s;\n\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: ", ";\n    font-size: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n\n  a:hover & {\n    color: ", ";\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 1.1em;\n  font-weight: 300;\n  line-height: 1.2;\n  letter-spacing: \"-.02em\";\n  margin: 0.5rem 0 0 0;\n  padding-left: 35%;\n\n  @media screen and (min-width: ", ") {\n    padding-left: 33%;\n    font-size: 1.2em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 31%;\n    font-size: 1.3em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 29%;\n    font-size: 1.4em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 1.5em;\n  }\n"], ["\n  color: ", ";\n  font-size: 1.1em;\n  font-weight: 300;\n  line-height: 1.2;\n  letter-spacing: \"-.02em\";\n  margin: 0.5rem 0 0 0;\n  padding-left: 35%;\n\n  @media screen and (min-width: ", ") {\n    padding-left: 33%;\n    font-size: 1.2em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 31%;\n    font-size: 1.3em;\n  }\n  @media screen and (min-width: ", ") {\n    padding-left: 29%;\n    font-size: 1.4em;\n  }\n  @media screen and (min-width: ", ") {\n    font-size: 1.5em;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  bottom: 0;\n  width: 25%;\n  left: 3px;\n  position: absolute;\n  box-shadow: ", ";\n  overflow: hidden;\n  top: ", ";\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n  }\n  .gatsby-image-wrapper {\n    height: 100%;\n  }\n\n  @media (min-width: ", ") {\n    a:hover & {\n      ", ";\n    }\n  }\n"], ["\n  bottom: 0;\n  width: 25%;\n  left: 3px;\n  position: absolute;\n  box-shadow: ", ";\n  overflow: hidden;\n  top: ", ";\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n  .gatsby-image-outer-wrapper {\n    height: 100%;\n  }\n  .gatsby-image-wrapper {\n    height: 100%;\n  }\n\n  @media (min-width: ", ") {\n    a:hover & {\n      ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(57);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var wrapperShowUp = (0, _styledComponents.keyframes)(_templateObject);
	
	var Wrapper = _styledComponents2.default.nav(_templateObject2, function (props) {
	  return props.isAside ? props.inTransition ? "block" : "none" : "block";
	}, function (props) {
	  return props.theme.navigator.backgrounds.wrapper;
	}, function (props) {
	  return props.isAside ? function (props) {
	    return "-" + props.theme.navigator.sizes.asideWidth;
	  } : "0";
	}, function (props) {
	  return props.theme.topBar.sizes.height;
	}, function (props) {
	  return props.isAside ? props.theme.navigator.sizes.asideWidth : "100%";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.isAside ? function (props) {
	    return props.theme.topBar.sizes.height + 12;
	  } : function (props) {
	    return props.theme.topBar.sizes.height + 18;
	  };
	}, function (props) {
	  return props.theme.mediaQueryThresholds.L;
	}, function (props) {
	  return props.theme.navigator.colors.scrollTrack;
	}, function (props) {
	  return props.theme.navigator.colors.scrollThumb;
	}, function (props) {
	  return props.isAside ? "1em 1em 1em .8em" : "2em 1.5em";
	});
	
	var headerShowUp = (0, _styledComponents.keyframes)(_templateObject3);
	
	var Header = _styledComponents2.default.header(_templateObject4, function (props) {
	  return props.isAside ? "block" : "none";
	}, function (props) {
	  return props.theme.navigator.colors.header;
	});
	
	var List = _styledComponents2.default.ul(_templateObject5, function (props) {
	  return props.inTransition ? "none" : "block";
	}, function (props) {
	  return props.theme.navigator.sizes.maxWidth;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.S;
	}, function (props) {
	  return !props.isAside ? "0 1.5em" : "";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return !props.isAside ? "0 2em" : "";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.L;
	}, function (props) {
	  return !props.isAside ? "0 3em" : "";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	}, function (props) {
	  return !props.isAside ? "0" : "";
	});
	
	var itemShowUp = (0, _styledComponents.keyframes)(_templateObject6);
	
	var ListItem = _styledComponents2.default.li(_templateObject7, itemShowUp, function (props) {
	  return props.isActive ? function (props) {
	    return props.theme.navigator.backgrounds.asideItemActive;
	  } : "none";
	}, function (props) {
	  return props.isActive ? function (props) {
	    return props.theme.navigator.colors.asideItemActiveBorder;
	  } : props.theme.navigator.backgrounds.wrapper;
	}, function (props) {
	  return props.isAside ? "1px solid rgba(255, 255, 255, 0.1)" : "";
	});
	
	var Post = _styledComponents2.default.div(_templateObject8);
	
	var Title = _styledComponents2.default.h2(_templateObject9, function (props) {
	  return props.theme.navigator.colors.title;
	}, function (props) {
	  return props.isAside ? "400" : "700";
	}, function (props) {
	  return props.isAside ? ".95em" : "1.3em";
	}, function (props) {
	  return props.isAside ? "0" : "-.04em";
	}, function (props) {
	  return props.isAside ? "1.15" : "1.1";
	}, function (props) {
	  return props.inTransition ? "0" : "1";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.S;
	}, function (props) {
	  return !props.isAside ? "33%" : "";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return !props.isAside ? "31%" : "";
	}, function (props) {
	  return !props.isAside ? "1.7em" : "";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.L;
	}, function (props) {
	  return !props.isAside ? "29%" : "";
	}, function (props) {
	  return !props.isAside ? "2em" : "";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	}, function (props) {
	  return !props.isAside ? "2.2em" : "";
	}, function (props) {
	  return props.theme.navigator.colors.linkHover;
	});
	
	var SubTitle = _styledComponents2.default.h3(_templateObject10, function (props) {
	  return props.theme.navigator.colors.subTitle;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.S;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.M;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.L;
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	});
	
	var Picture = _styledComponents2.default.div(_templateObject11, function (props) {
	  return !props.isAside ? "0 2px 1px rgba(0,0,0,.2)" : "";
	}, function (props) {
	  return props.isAside ? "0" : "5px";
	}, function (props) {
	  return props.theme.mediaQueryThresholds.XL;
	}, function (props) {
	  return !props.isAside ? "\n      transform: rotateY(15deg) rotateX(-15deg) translateY(-20%);\n      box-shadow: 0 20px 10px -10px rgba(0,0,0,.2);\n      height: 150%;" : "";
	});
	
	var PostsNavigator = function (_React$Component) {
	  _inherits(PostsNavigator, _React$Component);
	
	  function PostsNavigator(props) {
	    _classCallCheck(this, PostsNavigator);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isAside: false
	    };
	    return _this;
	  }
	
	  PostsNavigator.prototype.componentDidMount = function componentDidMount() {};
	
	  PostsNavigator.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      Wrapper,
	      {
	        isAside: this.props.isAside,
	        inTransition: this.props.inTransition,
	        isHidden: this.props.isHidden,
	        welcomeIsRolledUp: this.props.welcomeIsRolledUp
	      },
	      _react2.default.createElement(
	        Header,
	        { isAside: this.props.isAside },
	        "List of Posts: "
	      ),
	      _react2.default.createElement(
	        List,
	        {
	          isAside: this.props.isAside,
	          inTransition: this.props.inTransition
	        },
	        this.props.posts && this.props.posts.map(function (post) {
	          var title = post.node.frontmatter.title || post.node.path;
	          return _react2.default.createElement(
	            ListItem,
	            {
	              isActive: post.node.frontmatter.path === _this2.props.location,
	              isAside: _this2.props.isAside,
	              inTransition: _this2.props.inTransition,
	              key: post.node.frontmatter.path
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: post.node.frontmatter.path,
	                onClick: _this2.props.linkOnClick
	              },
	              _react2.default.createElement(
	                Post,
	                null,
	                _react2.default.createElement(
	                  Title,
	                  { isAside: _this2.props.isAside },
	                  post.node.frontmatter.title
	                ),
	                !_this2.props.isAside && _react2.default.createElement(
	                  SubTitle,
	                  { isAside: _this2.props.isAside },
	                  post.node.frontmatter.subTitle
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return PostsNavigator;
	}(_react2.default.Component);
	
	exports.default = PostsNavigator;
	module.exports = exports["default"];

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _store = __webpack_require__(14);
	
	var _PostsNavigator = __webpack_require__(50);
	
	var _PostsNavigator2 = _interopRequireDefault(_PostsNavigator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostsNavigatorContainer = function (_React$Component) {
	  _inherits(PostsNavigatorContainer, _React$Component);
	
	  function PostsNavigatorContainer(props) {
	    _classCallCheck(this, PostsNavigatorContainer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.linkOnClick = _this.linkOnClick.bind(_this);
	    return _this;
	  }
	
	  PostsNavigatorContainer.prototype.linkOnClick = function linkOnClick() {
	    var _this2 = this;
	
	    if (!this.props.isAside) {
	      this.props.setIsAside(true);
	      this.props.setInTransition(true);
	
	      setTimeout(function () {
	        _this2.props.setInTransition(false);
	      }, 800);
	    }
	  };
	
	  PostsNavigatorContainer.prototype.render = function render() {
	    var type = this.props.type;
	    if (type == "blog-post") {
	      return !!this.props.posts.length ? _react2.default.createElement(_PostsNavigator2.default, {
	        location: this.props.location,
	        posts: this.props.posts,
	        linkOnClick: this.linkOnClick,
	        isAside: this.props.isAside,
	        inTransition: this.props.inTransition,
	        isHidden: this.props.isHidden
	      }) : null;
	    }
	    if (type == "project") {
	      return !!this.props.projects.length ? _react2.default.createElement(_PostsNavigator2.default, {
	        location: this.props.location,
	        posts: this.props.projects,
	        linkOnClick: this.linkOnClick,
	        isAside: this.props.isAside,
	        inTransition: this.props.inTransition,
	        isHidden: this.props.isHidden
	      }) : null;
	    } else {
	      return null;
	    }
	  };
	
	  return PostsNavigatorContainer;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    posts: state.posts,
	    type: state.type,
	    projects: state.projects,
	    isAside: state.navigator.isAside,
	    inTransition: state.navigator.inTransition,
	    isActive: state.posts.length
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setIsAside: function setIsAside(val) {
	      return dispatch((0, _store.setNavigatorIsAside)(val));
	    },
	    setInTransition: function setInTransition(val) {
	      return dispatch((0, _store.setNavigatorInTransition)(val));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostsNavigatorContainer);
	module.exports = exports["default"];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _store = __webpack_require__(14);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PostsNavigatorContainer = __webpack_require__(51);
	
	var _PostsNavigatorContainer2 = _interopRequireDefault(_PostsNavigatorContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = __webpack_require__(15);
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogIndex.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var isWideScreen = typeof window !== "undefined" ? document.documentElement.clientWidth > 776 : false;
	
	    var posts = this.props.data.allMarkdownRemark.edges;
	    this.props.updatePostsData(posts);
	
	    this.props.setNavigatorIsAside(false);
	    if (typeof window !== "undefined") {
	      this.props.setNavigatorInTransition(true);
	      setTimeout(function () {
	        _this2.props.setNavigatorInTransition(false);
	      }, isWideScreen ? 500 : 0);
	    }
	  };
	
	  BlogIndex.prototype.render = function render() {
	    return _react2.default.createElement(_reactHelmet2.default, { title: config.siteTitle });
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorIsAside: state.navigator.isAside,
	    navigatorIsActive: state.posts.length
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    updatePostsData: function updatePostsData(data) {
	      return dispatch((0, _store.updatePostsData)(data));
	    },
	    setNavigatorIsAside: function setNavigatorIsAside(val) {
	      return dispatch((0, _store.setNavigatorIsAside)(val));
	    },
	    setNavigatorInTransition: function setNavigatorInTransition(val) {
	      return dispatch((0, _store.setNavigatorInTransition)(val));
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BlogIndex);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blogs-js-565c88941e00ff4b6023.js